import { render, staticRenderFns } from "./CleaverMatch.vue?vue&type=template&id=4d616cf7&scoped=true&"
import script from "./CleaverMatch.vue?vue&type=script&lang=js&"
export * from "./CleaverMatch.vue?vue&type=script&lang=js&"
import style0 from "./CleaverMatch.vue?vue&type=style&index=0&id=4d616cf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d616cf7",
  null
  
)

export default component.exports